import React, { Fragment, Component } from "react";
import c3 from 'c3';

class StackedBarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };

  }
  renderChart(data) {
    c3.generate({
      bindto: '#' + data.chartId,
      interaction: {
        enabled: true
      },
      data: {
        columns: data.barData,
        type: 'bar',
        colors: data.dataColor,
        labels: true
      },
      axis: {
        x: {
          type: data.xType,
          categories: data.xCategory
        },
        y: { show: data.isYAxis }
      },
      bar: {
        width: {
          ratio: data.width ? data.width : 0.5
        }
      },
      legend: {
        show: true
      },
      tooltip: {
        position: function (data, width, height, element) {
          return { top: 0, right: '10px' }
        }
      },
      grid: {
        y: {
          lines: [{ value: 0 }]
        }
      }
    });
  }

  componentDidMount() {
    this.renderChart(this.props);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.barData !== this.props.barData) {
      this.renderChart(this.props);
    }
  }


  render() {
    const { chartId } = this.props;
    return (
      <Fragment>
        <div id={chartId}></div>
      </Fragment>
    );
  }
}

export default StackedBarChart;
